/* eslint-disable no-use-before-define */

// THIS IS A COPY OF A FILE FROM ORDERWEB. IF YOU WANT TO UPDATE IT PLEASE KEEP THE
// TWO VERSIONS IN SYNC
// https://github.com/deliveroo/orderweb/blob/master/client/app/lib/util/speedTracking.js
//
function speedTrackingCreator(pageName, customTrackingTags = [], getTTI = () => {}) {
  return () => speedTracking(window, pageName, customTrackingTags, getTTI());
}
export default speedTrackingCreator;

export function speedTracking(window, pageName, customTrackingTags, tti) {
  const win = window;

  // if we've already reported metrics don't do it again
  if (win.timingsSent) {
    return true;
  }
  win.timingsSent = true;

  // if we don't have sendBeacon fail fast
  if (!win.navigator.sendBeacon) {
    return true;
  }

  // if we don't have performance entries fail fast as we also won't have page
  // size so there is nothing to report, if we don't have page sizes later
  // thats, fine as we can still report these times.
  if (!win.performance.timing) {
    return true;
  }

  const timingData = {
    ...pageTimeMetrics(win),
    ...pageSizeMetrics(win),
    ...ttiMetric(tti),
    // pageTimeMetrics measure a duration, firstContentfulPaint is a point
    firstContentfulPaint: firstContentfulPaint(win),
    pageName,
    customTrackingTags,
  };

  win.navigator.sendBeacon('/en/page-times', JSON.stringify(timingData));

  return true;
}

function ttiMetric(tti) {
  if (tti) {
    return { timeToInteractive: tti };
  }
  return {};
}

function pageTimeMetrics(window) {
  const timings = window.performance.timing;

  return {
    requestStart: timings.requestStart - timings.fetchStart,
    responseStart: timings.responseStart - timings.requestStart, // Time taken for SSR to complete
    responseEnd: timings.responseEnd - timings.responseStart, // Time taken for the Browser to receive the full response
    browserParsedResponse: timings.domInteractive - timings.responseEnd, // Time taken for the Browser to parse the response
    browserInteractive: timings.domComplete - timings.domInteractive, // Time taken for the browser to execute the Javascript and make the page fully interactive.
    domInteractive: timings.domInteractive - timings.responseEnd,
    domContentLoaded: timings.domContentLoadedEventEnd - timings.domInteractive,
    domComplete: timings.domComplete - timings.navigationStart, // Time taken from the start of a request to the page fully rendering with most assets.
  };
}

function firstContentfulPaint(window) {
  if (window.performance.getEntries) {
    const entries = window.performance
      .getEntries()
      .filter((entry) => entry.name === 'first-contentful-paint');
    if (entries[0]) {
      // `PerformancePaintTiming` records startTime in ms, with 5 µs precision
      return Math.floor(entries[0].startTime);
    }
  }
  return 0;
}

function pageSizeMetrics(window) {
  let pageSize = 0;
  let cssSize = 0;
  let javaScriptSize = 0;
  let assetSize = 0;
  let fontSize = 0;
  let domContentLoadedSize = 0;

  if (window.performance.getEntries) {
    const entries = window.performance.getEntries();
    let domContentLoadedEnd = 0;

    entries.forEach((entry) => {
      switch (entry.initiatorType) {
        case 'navigation':
          pageSize = entry.transferSize;
          domContentLoadedEnd = entry.domContentLoadedEventEnd;
          break;
        case 'link':
          if (entry.name.match(/\.css/)) {
            cssSize += entry.transferSize;
          } else if (entry.name.match(/\.js/)) {
            javaScriptSize += entry.transferSize;
          } else if (entry.name.match(/\.woff/)) {
            fontSize += entry.transferSize;
          }
          break;
        case 'img':
        case 'css':
          if (entry.name.match(/\.woff/)) {
            fontSize += entry.transferSize;
          } else {
            assetSize += entry.transferSize;
          }
          break;
        case 'script':
          javaScriptSize += entry.transferSize;
          break;
        default:
      }
      if (typeof entry.transferSize === 'number' && entry.responseEnd < domContentLoadedEnd) {
        domContentLoadedSize += entry.transferSize;
      }
    });
  }
  return {
    pageSize,
    cssSize,
    javaScriptSize,
    assetSize,
    fontSize,
    domContentLoadedSize,
  };
}
